(function () {
  var btn = document.getElementById('btt-global');
  if (!btn) return;

  btn.addEventListener('click', function () {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  var basePad = parseFloat(btn.dataset.basePad || '24');
  var pct = parseFloat(btn.dataset.showPercent || '75');
  var threshold = 1 - pct / 100;

  // Place le bouton au-dessus d'une barre sticky (fiche produit) si presente
  function stickyOffset() {
    var bars = document.querySelectorAll('.sticky-atc, .pdv-sticky, [data-sticky-atc]');
    var top = 0;
    bars.forEach(function (bar) {
      if (bar === btn) return;
      var cs = getComputedStyle(bar);
      if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return;
      var r = bar.getBoundingClientRect();
      if (r.height < 1 || r.bottom < window.innerHeight * 0.5) return;
      var fromBottom = window.innerHeight - r.top; // hauteur occupee en bas
      if (fromBottom > top) top = fromBottom;
    });
    return top > 0 ? Math.round(top + 12) : 0;
  }

  function place() {
    var off = stickyOffset();
    btn.style.bottom = (off > 0 ? off : basePad) + 'px';
  }

  function toggle() {
    var max = document.body.scrollHeight - window.innerHeight;
    if (max <= 0 || window.scrollY > threshold * max) {
      btn.classList.add('is-visible');
    } else {
      btn.classList.remove('is-visible');
    }
    place();
  }

  place();
  window.addEventListener('load', place);
  window.addEventListener('resize', place, { passive: true });

  // Recalcule a l'apparition d'une barre sticky (slide-out a delai)
  var lastOff = -1;
  function watch() {
    var off = stickyOffset();
    if (off !== lastOff) { lastOff = off; place(); }
  }
  var ticks = 0;
  var iv = setInterval(function () { watch(); if (++ticks > 24) clearInterval(iv); }, 250);
  if ('ResizeObserver' in window) {
    var bar = document.querySelector('.sticky-atc, .pdv-sticky, [data-sticky-atc]');
    if (bar) { try { new ResizeObserver(place).observe(bar); } catch (e) {} }
  }

  if (threshold >= 1) {
    btn.classList.add('is-visible');
    place();
  } else {
    window.addEventListener('scroll', toggle, { passive: true });
    window.addEventListener('resize', toggle, { passive: true });
    toggle();
  }
})();
